import axios from 'axios';
import { createSlice } from '@reduxjs/toolkit';

const initialState = {

     task_id : '',
     status : '',

     success_result : {
         id: '',
         domain: '',
         database: '',
         username: '',
         password: '',
         created_date: '',
         modified_date: '',
         status: null
     },

     failure_result : {
         error_type : '',
         error_message : '',
         traceback : ''
     },

};


export const TenantSetupSlice = createSlice({

  name: 'tenant_setup_slice',
  initialState,
  reducers: {

      tenant_setup : (state, action) => {
          console.log('TenantSetupSlice:tenant_setup')
          console.log(action.payload)
          const data = action.payload
          return {
              ...state,
              ...data
          }
      },

      task_status : (state, action) => {
          console.log('TenantSetupSlice:task_status')
          console.log(action.payload)
          const  payload= action.payload
          const task_status = payload.status
          if (task_status === 'SUCCESS') {

              return {
                  ...state,
                  task_id : payload.task_id,
                  status : payload.status,
                  success_result : {
                      ...state.success_result,
                      ...payload.result
                  }
              }
          } else  if(task_status === 'FAILURE') {

              return {
                  ...state,
                  task_id : payload.task_id,
                  status : payload.status,
                  failure_result : {
                      ...state.failure_result,
                      error_type: payload.error_type,
                      error_message : payload.error_message,
                      traceback : payload.traceback
                  }
              }
         } else {
              return {
                  ...state,
                  task_id : payload.task_id,
                  status : payload.status,
              }

        }

      },
  }
});


export const { 
  tenant_setup,
  task_status
} = TenantSetupSlice.actions;

export default TenantSetupSlice.reducer;
